import ControlledInput from "@components/common/ControlledInput";
import { Divider, Stack, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import type { PrismaFilter, WhereFilter } from "@types_def/common/filter.types";
import type { Delivery } from "@types_def/models/delivery.types";
import { useTranslation } from "react-i18next";

type DeliveryTableDeliveryDateFilterProps = {
  from?: boolean;
  filter?: WhereFilter<Delivery>;
  handleDateChange?: (
    date: Date | undefined | null,
    prop: keyof PrismaFilter<Delivery, "carDeliveryDeadline">
  ) => void;
};

function DeliveryTableDeliveryDateFilter({
  from,
  filter,
  handleDateChange,
}: DeliveryTableDeliveryDateFilterProps) {
  const { t } = useTranslation();

  if (handleDateChange) {
    const filterKey: keyof PrismaFilter<Delivery, "carDeliveryDeadline"> = from ? "gte" : "lte";
    const rawDateValue = filter?.carDeliveryDeadline?.[filterKey];
    const currentValue =
      typeof rawDateValue === "string" || rawDateValue instanceof Date
        ? new Date(rawDateValue)
        : null;

    return (
      <DatePicker
        label={from ? t("common.shared.from") : t("common.shared.to")}
        onChange={(value) => handleDateChange(value ?? undefined, filterKey)}
        slotProps={{
          textField: {
            size: "small",
          },
        }}
        value={currentValue}
      />
    );
  }

  return (
    <>
      <Typography variant="body2" letterSpacing={2} fontWeight={600}>
        {" "}
        {t("common.table.headers.Date de livraison")}
      </Typography>
      <Divider />
      <Stack
        margin={1}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
      >
        <ControlledInput name="carDeliveryDeadlineFrom" label={t("common.shared.from")}>
          <DatePicker
            slotProps={{
              textField: {
                fullWidth: true,
                size: "small",
              },
            }}
          />
        </ControlledInput>
        <ControlledInput name="carDeliveryDeadlineTo" label={t("common.shared.to")}>
          <DatePicker
            slotProps={{
              textField: {
                fullWidth: true,
                size: "small",
              },
            }}
          />
        </ControlledInput>
      </Stack>
    </>
  );
}

export default DeliveryTableDeliveryDateFilter;
